import React, { useEffect, useState } from "react";
import { fetchBalance, fetchSigner } from "@wagmi/core";
import { useAccount, useNetwork } from "wagmi";
import toast from "react-hot-toast";
import { custom_network } from "../../utils";
import { ethers } from "ethers";
import "./token.css";

import Header from "../header/header";
import Roadmap from "../../components/Roadmap";
import * as Element from "./style";
import swardImg from "../../assets/images/images/coinLogo.svg";

import {
  fetchDRAC24Rewards,
  fetchBabyDracBalance,
  stakeTokens,
  approveTokenSpending,
  redeemRewards,
  babyDracTokenAddress,
  stakingContractAddress,
  fetchAllowance,
  fetchTotalBabyDracBalance,
  getTokenInfo,
  fetchRewardPerTokenPeriod,
  fetchDaysPerPeriod,
} from "../../utils/contracts";

const Home = (props) => {
  const { chain } = useNetwork();
  const { address, isConnected, connector: activeConnector } = useAccount();
  const [balance, setBalance] = useState(0);
  const [walletBalance, setWalletBalance] = useState(0);
  const [userDracBalance, setUserDracBalance] = useState(0);
  const [drac24Rewards, setDrac24Rewards] = useState(0);
  const [stakeAmount, setStakeAmount] = useState("");
  const [isApproved, setIsApproved] = useState(false);
  const [mainToken, setMainToken] = useState("");
  const [rewardToken, setRewardToken] = useState("");
  const [rewardWallet, setRewardWallet] = useState("");
  const [rewardPerTokenPeriod, setRewardPerTokenPeriod] = useState("");
  const [daysPerPeriod, setDaysPerPeriod] = useState("");
  //   const [totalStaked, setTotalStaked] = useState(0);
  //   const [totalStakedGlobal, setTotalStakedGlobal] = useState(0);

  const inputStyle = {
    background: "#222",
    color: "#fff",
    padding: "10px",
    margin: "10px 0",
    border: "2px solid green", // Green border
    boxShadow: "0px 0px 10px green", // Green shadow
    borderRadius: "5px", // Rounded corners
  };

  useEffect(() => {
    const fetchTokenInfo = async () => {
      const info = await getTokenInfo();
      if (info) {
        setMainToken(info.mainToken); // set mainToken address
        setRewardToken(info.rewardToken); // set rewardToken address
        setRewardWallet(info.rewardWallet);
      }
    };

    fetchTokenInfo();
  }, []);

  useEffect(
    () => {
      // Function to fetch contract details
      const fetchContractDetails = async () => {
        const rewardPerToken = await fetchRewardPerTokenPeriod();
        const days = await fetchDaysPerPeriod();

        setRewardPerTokenPeriod(rewardPerToken);
        setDaysPerPeriod(days);
      };

      fetchContractDetails();
    },
    [
      /* dependencies, if any */
    ]
  );

  const refreshRewards = async () => {
    if (address && isConnected) {
      try {
        const updatedRewards = await fetchDRAC24Rewards(address);
        setDrac24Rewards(updatedRewards);
      } catch (error) {
        console.error("Error Fetching Updated Rewards:", error);
      }
    }
  };

  useEffect(() => {
    if (address && isConnected && chain && chain.id === custom_network.id) {
      fetchBalance({
        address: address,
      })
        .then((result) => {
          // ... Handle the balance ...
        })
        .catch((error) => {
          console.error("Balance Fetch Error:", error);
          setBalance(0);
        });

      const fetchUserData = async () => {
        const stakedBalance = await fetchBabyDracBalance(address);
        const rewards = await fetchDRAC24Rewards(address);
        setUserDracBalance(stakedBalance);
        setDrac24Rewards(rewards);

        // Fetch the total balance using the provider
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        if (provider) {
          const totalBalance = await fetchTotalBabyDracBalance(
            address,
            provider
          );
          setWalletBalance(totalBalance);
        }
      };

      fetchUserData().catch(console.error);
      //   refreshGlobalStake();
      const interval = setInterval(() => {
        refreshRewards();
        //  refreshGlobalStake();
      }, 30000);
      return () => clearInterval(interval);
    }
  }, [address, isConnected, chain]);

  const [TokenInfo, setTokenInfo] = useState({
    name: 0,
  });

  const handleApproval = async () => {
    if (!stakeAmount || isNaN(stakeAmount) || parseFloat(stakeAmount) <= 0) {
      toast.error("Please Enter A Valid Amount!");
      return;
    }

    const signer = await fetchSigner();
    const amountInWei = ethers.utils.parseUnits(stakeAmount.toString(), 18);
    const loadingToastId = toast.loading(
      "Approving... Do Not Refresh The Page, Please Wait!"
    ); // Initiate loading toast

    try {
      const tx = await approveTokenSpending(
        babyDracTokenAddress,
        stakingContractAddress,
        amountInWei,
        signer
      );
      const receipt = await tx.wait();
      toast.dismiss(loadingToastId); // Dismiss the loading toast regardless of the outcome

      if (receipt.status === 1) {
        toast.success("Approval Successful!");
        setIsApproved(true);
      } else {
        toast.error("Approval Transaction Failed.");
      }
    } catch (error) {
      toast.dismiss(loadingToastId); // Dismiss the loading toast on error
      console.error("Error Approving Tokens:", error);
      toast.success("Approval Process Initiated. Check Wallet To Confirm.");
    }
  };

  const handleStake = async () => {
    const signer = await fetchSigner();
    const currentAllowanceWei = await fetchAllowance(
      address,
      stakingContractAddress,
      babyDracTokenAddress,
      signer
    );

    if (!currentAllowanceWei || parseFloat(currentAllowanceWei) === 0) {
      toast.error(
        "No Approved Baby Drac To Stake. Please Approve Token Spend First!"
      );
      return;
    }

    const loadingToastId = toast.loading(
      "Staking... DO NOT Refresh The Page, Please Wait!"
    ); // Initiate loading toast

    try {
      const tx = await stakeTokens(currentAllowanceWei, signer);
      const receipt = await tx.wait();
      toast.dismiss(loadingToastId); // Dismiss the loading toast regardless of the outcome

      if (receipt.status === 1) {
        toast.success("Stake Successful!");
        const updatedBalance = await fetchBabyDracBalance(address);
        const updatedRewards = await fetchDRAC24Rewards(address);
        setUserDracBalance(updatedBalance);
        setDrac24Rewards(updatedRewards);
      } else {
        toast.error("Stake Transaction Failed.");
      }
    } catch (error) {
      toast.dismiss(loadingToastId); // Dismiss the loading toast on error
      console.error("Error Staking Tokens:", error);
      toast.success("Stake Successful!");
    }
  };

  const handleRedeem = async () => {
    const loadingToastId = toast.loading(
      "Redeeming Rewards... DO NOT Refresh The Page, Please Wait!"
    );
    const signer = await fetchSigner();
    try {
      const tx = await redeemRewards(signer);
      if (tx && typeof tx.wait === "function") {
        console.log("Transaction Sent, Waiting For Confirmation...");
        const receipt = await tx.wait();
        console.log("Transaction Confirmed, Receipt:", receipt);
        toast.dismiss(loadingToastId);
        if (receipt.status === 1) {
          toast.success(
            "Rewards Redeemed Successfully!, Check Wallet To Confirm."
          );
          refreshRewards();
        } else {
          console.error("Transaction Failed With Receipt:", receipt);
          toast.error("Rewards Redemption Failed.");
        }
      } else {
        throw new Error(
          "Transaction object not returned or missing wait function."
        );
      }
    } catch (error) {
      toast.dismiss(loadingToastId);
      console.error("Error Redeeming Rewards:", error);
      toast.error("Failed To Redeem Rewards.");
    }
  };

  //    const handleWithdraw = async () => {
  //       if (!withdrawAmount || isNaN(withdrawAmount)) {
  //         toast.error("Please enter a valid amount!");
  //         return;
  //       }

  //       const amountToWithdraw = parseFloat(withdrawAmount);
  //       const userBalance = parseFloat(userDracBalance);

  //       if (amountToWithdraw <= 0 || amountToWithdraw > userBalance) {
  //         toast.error("Please enter an amount that is within your balance!");
  //         return;
  //       }

  //       const signer = await fetchSigner();
  //       const amountInWei = ethers.utils.parseUnits(withdrawAmount.toString(), 18);
  //       console.log(`Attempting to withdraw: ${withdrawAmount} Baby Drac (${amountInWei} in Wei)`);

  //       try {
  //          const { success, error } = await withdrawTokens(amountInWei, signer);
  //          if (success) {
  //              toast.success("Tokens withdrawn successfully!");
  //              // ... update state as needed ...
  //          } else {
  //              toast.error(`Failed to withdraw tokens. Error: ${error.message}`);
  //          }
  //      } catch (error) {
  //          console.error("Error withdrawing tokens:", error);
  //          toast.error("Unexpected error. See console for more details.");
  //      }
  //  };

  return (
    <div>
      <Header {...props} />
      <Element.Container>
        <div className="things">
          <img src={swardImg} alt="Main Logo" />
          <h2 style={{ color: "#9ED104" }}>
            BABY DRAC PRE-SALE{" "}
            <i style={{ color: "#fff" }}>EXECUTIVE DIVIDENDS</i>
          </h2>

          {isConnected && (
            <>
              <div className="token-box">
                <p className="left">MY BDRAC BALNACE:</p>
                <p className="right">{walletBalance}</p>
              </div>
              <div className="token-box">
                <p className="left">STAKED BABY DRAC:</p>
                <p className="right">{userDracBalance}</p>
              </div>
              <div className="token-box">
                <p className="left">DRAC24 REWARDS:</p>
                <p className="right">{drac24Rewards}</p>
              </div>
              {/* <div className='content-row'>
               <p className='left'>TOTAL STAKED GLOBALLY:</p>
               <p className='right'>{totalStakedGlobal}</p>
            </div> */}
            </>
          )}

          {isConnected && (
            <div>
              <input
                style={inputStyle}
                type="number"
                value={stakeAmount}
                onChange={(e) => setStakeAmount(e.target.value)}
                placeholder="Enter Baby Drac amount to stake"
              />
              <div className="button-851" onClick={handleApproval}>
                <i>APPROVE</i>
              </div>
              <div className="button-851" onClick={handleStake}>
                <i>STAKE NOW</i>
              </div>
              <div className="button-851" onClick={handleRedeem}>
                <i>REDEEM REWARDS</i>
              </div>
            </div>
          )}
        </div>
      </Element.Container>
      <h1 className="token-title">Baby Drac Contract</h1>
      <div className="token-container">
        {" "}
        {/* New container for centering */}
        <div className="token-box">
          <h2 className="token-title">Baby Drac:</h2>
          <a
            href={`https://goerli.etherscan.io/address/0xcb7b6bacda7aaa73fd1d02ab2aee9f2a09b6ccc6/${mainToken}`}
            target="_blank"
            rel="noopener noreferrer"
            className="token-value"
          >
            {mainToken}
          </a>
        </div>
        <div className="token-box">
          <h2 className="token-title">Reward Token:</h2>
          <a
            href={`https://goerli.etherscan.io/address/0x127315b7d14d84f351984578948c1d89b80717cf/${rewardToken}`}
            target="_blank"
            rel="noopener noreferrer"
            className="token-value"
          >
            {rewardToken}
          </a>
        </div>
        <div className="token-box">
          <h2 className="token-title">Reward Wallet:</h2>
          <a
            href={`https://goerli.etherscan.io/address/0x2a2cf9C06514494538E90Bb6b090DdB3792fA2FF/${rewardWallet}`}
            target="_blank"
            rel="noopener noreferrer"
            className="token-value"
          >
            {rewardWallet}
          </a>
        </div>
        <div className="token-box">
          <h2 className="token-title">Staking Contract:</h2>
          <a
            href={`https://goerli.etherscan.io/address/0xad509ad73df3961b79d716eb264848c212a1b229`}
            target="_blank"
            rel="noopener noreferrer"
            className="token-value"
          >
            0xAD509AD73dF3961B79D716Eb264848C212A1b229
          </a>
        </div>
        <div className="token-box">
          <h2 className="token-title">Days Per Period:</h2>
          <div className="token-value">{daysPerPeriod}</div>
        </div>
        <div className="token-box">
          <h2 className="token-title">Reward Per Token Period:</h2>
          <div className="token-value">{rewardPerTokenPeriod}</div>
        </div>
      </div>{" "}
      {/* End of the container */}
      <Roadmap />
    </div>
  );
};

export default Home;
